import { useState } from "react";
import { Menu } from "lucide-react";
import SplitText from "@/components/TitleSplitEffect";
import { FullScreenMenu } from "@/components/FullScreenMenu";

interface NavItem {
    name: string;
    href: string;
    description?: string;
    items?: NavItem[];
}

interface SiteHeaderProps {
    navItems: NavItem[];
}

export function SiteHeader({ navItems }: SiteHeaderProps) {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <div className="navigation w-full flex items-center">
            <button
                onClick={() => setIsMenuOpen(true)}
                className="py-2 cursor-pointer pl-0 mr-4 hover:opacity-70 transition-opacity"
                aria-label="Open menu"
            >
                <Menu className="w-6 h-6 text-slate-900" />
            </button>

            <SplitText
                mainText="Quizzler"
                subText="Test yourself"
                href="/"
                className="text-slate-900 font-medium"
            />

            <FullScreenMenu
                items={navItems}
                isOpen={isMenuOpen}
                onClose={() => setIsMenuOpen(false)}
            />
        </div>
    );
}
